//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { options } from "@/assets/js/city";
import {
  getEducation,
  getMajor,
  getProviderType,
  getCredit,
  getCreditIndustry,
  getJobTitle,
  getIndustry,
  getServiceContents,
  getBusinessType,
  getServiceTypes,
} from "@/assets/js/dict";
export default {
  created() {
    this.options = options;
    getEducation().then((res) => {
      this.educations = res;
    });
    getMajor().then((res) => {
      this.majors = res;
    });
    getProviderType().then((res) => {
      this.providers = res;
    });
    getCredit().then((res) => {
      this.credits = res;
    });
    getCreditIndustry().then((res) => {
      this.creditIndustrys = res;
    });
    getJobTitle().then((res) => {
      this.jobTitles = res;
    });
    getServiceContents().then((res) => {
      this.serviceList = res;
    });
    getIndustry().then((res) => {
      this.industrys = res;
    });
    getBusinessType().then((res) => {
      this.businessList = res;
    });
    getServiceTypes().then((res) => {
      for (var i = 0; i < res.length; i++) {
        if (res[i].dictCode == 1) {
          this.serviceTypeListB = res[i].children;
        }
        if (res[i].dictCode == 2) {
          this.serviceTypeListP = res[i].children;
        }
      }
    });
  },
  data() {
    return{
      info: "",
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() > Date.now();
      },
    },
    props: {
      multiple: true,
    },
    tip: 0,
    dianxi: 0, //典型业绩名称展示
    headers: {},
    providers: [],
    industry: [],
    industrys: [],
    majors: [],
    jobTitles: [],
    serviceList: [],
    credits: [],
    creditIndustrys: [],
    educations: [],
    userIndustryList: [],
    businessList: [],
    serviceTypeListB: [], //编制类服务类型
    serviceTypeListP: [], //评审类服务类型
    userBusinessParamList: [],
    userConsultCreditList: [
      {
        credit: "",
        industry: "",
      },
    ],
    placeholder: "",
    userPersonalExpertParam: {
      //个人信息
      realName: "",
      intro: "",
      jobTitle: "",
      idNumber: "",
      qualificationName: "",
      contactNumber: "",
      contactAddressCode: "",
      contactAddressDetail: "",
      userPersonalExpertList: [
        {
          storageName: "",
          storageTime: "",
        },
      ],
      isExpert: false,
      worktime: "",
    },
    userStudio: {
      //工作室信息
      realName: "",
      regTime: "",
      staffAmount: "",
      principalName: "",
      principalMobile: "",
      intro: "",
      jobTitle: "",
      qualificationName: "",
      contactNumber: "",
      contactAddressCode: "",
      contactAddressDetail: "",
    },
    userEnterprise: {
      //企业信息
      principalName: "",
      principalMobile: "",
      staffAmount: "",
      realName: "",
      regTime: "",
      regFund: "",
      intro: "",
      businessScope: "",
      contactAddressCode: "",
      contactAddressDetail: "",
    },
    personList: [
      {
        fileUrl: "",
        fileName: "",
        authFileType: "pcardzs",
        settledType: "1",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "pcardfs",
        settledType: "1",
        userType: 3,
      },
    ],
    workList: [
      {
        fileUrl: "",
        fileName: "",
        authFileType: "wcardz",
        settledType: "2",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "wcardf",
        settledType: "2",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "wzc",
        settledType: "2",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "wzg",
        settledType: "2",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "wyyzz",
        settledType: "2",
        userType: 3,
      },
    ],
    firmList: [
      {
        fileUrl: "",
        fileName: "",
        authFileType: "fyyzz",
        settledType: "3",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "fzxzs",
        settledType: "3",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "fcardz",
        settledType: "3",
        userType: 3,
      },
      {
        fileUrl: "",
        fileName: "",
        authFileType: "fcardf",
        settledType: "3",
        userType: 3,
      },
    ],
    otherList: [],
    other: 1, //其他证书
    srcList: [],
    xuanze: false,
    size: "normal",
    // eslint-disable-next-line no-dupe-keys
    headers: {},
    pzcLength: 0,
    pzgLength: 0,
    ryLength: 0,
    rkLength: 0,
    rules: {
        realName: {
          required: true,
          message: '请填写姓名',
          trigger: 'blur'
        },
        serviceContent: {
          required: false,
          message: '请选择服务内容',
          trigger: 'blur'
        },
        contactNumber: [{
          required: true,
          validator: this.mobileValid,
          trigger: 'blur'
        },
        {
          max: 11,
          message: '长度为11位',
          trigger: 'blur'
        }
        ],
        idNumber: [{
          required: true,
          validator: this.numberValid,
          trigger: 'blur',
        },
        {
          max: 18,
          message: '长度为18位',
          trigger: 'blur'
        }
        ],
        contactAddressCode: {
          required: true,
          message: '请选择省市',
          trigger: 'change'
        },
        contactAddressDetail: {
          required: true,
          message: '请填写详细地址',
          trigger: 'blur'
        },
        regTime: {
          required: true,
          message: '请选择日期',
          trigger: 'change'
        },
        regFund: {
          required: true,
          message: '请填写注册资金',
          trigger: 'blur'
        },
        businessScope: {
          required: true,
          message: '请填写经营范围',
          trigger: 'blur'
        },
        intro: {
          required: true,
          message: '请填写简介',
          trigger: 'blur'
        },
        jobTitle: {
          required: true,
          message: '请选择技术职称',
          trigger: 'change'
        },
        isExpert: {
          required: true,
          message: '请选择是否申请加入平台专家库',
          trigger: 'change'
        },
        education: {
          required: true,
          message: '请选择专家学历',
          trigger: 'change'
        },
        workYears: {
          required: true,
          message: '请选择开始从业年份',
          trigger: 'blur'
        },
        workCompany: {
          required: true,
          message: '请填写工作单位',
          trigger: 'blur'
        },
        workMajor: {
          required: true,
          message: '请选择从事专业',
          trigger: 'change'
        },
        staffAmount: {
          required: true,
          message: '请填写人数',
          trigger: 'blur'
        },
        principalName: {
          required: true,
          message: '请填写负责人姓名',
          trigger: 'blur'
        },
        userConsultCreditList: {
          required: false,
          message: '请选择资信级别',
          trigger: 'change'
        },
        principalMobile: [
          {
            required: true,
            validator: this.mobileValid,
            trigger: 'blur'
          },
          {
            max: 11,
            message: '长度为11位',
            trigger: 'blur'
          }
        ],
        industry: {
          required: false,
          message: '请选择服务行业',
          trigger: 'change'
        },
      },
    }
    
  },
  methods: {
    // 手机号码校验
    mobileValid(rule, value, callback) {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('请输入正确手机号码'));
          this.isgetverifycode = false;
        } else {
          this.isgetverifycode = true;
          callback();
        }
      },
      numberValid(rule, val, callback) {
        var checkCode = function(val) {
          var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, ];
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var code='';
          if(val){
             code= val.substring(17);
          }
          if (p.test(val)) {
            var sum = 0;
            for (var i = 0; i < 17; i++) {
              sum += val[i] * factor[i];
            }
            if (parity[sum % 11] == code.toUpperCase()) {
              return true;
            }
          }
          return false;
        };
        var checkDate = function(val) {
          var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
          if (pattern.test(val)) {
            var year = val.substring(0, 4);
            var month = val.substring(4, 6);
            var date = val.substring(6, 8);
            var date2 = new Date(year + "-" + month + "-" + date);
            if (date2 && date2.getMonth() == parseInt(month) - 1) {
              return true;
            }
          }
          return false;
        };
        var checkProv = function(val) {
          var pattern = /^[1-9][0-9]/;
          var provs = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
          };
          if (pattern.test(val)) {
            if (provs[val]) {
              return true;
            }
          }
          return false;
        };
        if (checkCode(val)) {
          var date = val.substring(6, 14);
          if (checkDate(date)) {
            if (checkProv(val.substring(0, 2))) {
              callback();
            }
          }
        } else {
          callback(new Error("请输入正确的身份证号码"));
          return false;
        }
      },
    // 获取个人信息
    getInfo() {
      this.$get("/sys/user/info", "", function (res) {
        this.info = res.data;
        var userBusinessParamList = res.data.userBusinessParamList;
        for (var i = 0; i < userBusinessParamList.length; i++) {
          if (userBusinessParamList[i].settledType == this.$route.query.type) {
            if (userBusinessParamList[i].achievementList.length == 0) {
              userBusinessParamList[i].achievementList = [{}];
            }
            if (this.$route.query.type == 2 || this.$route.query.type == 3) {
              if (userBusinessParamList[i].serviceType.indexOf(",") != -1) {
                userBusinessParamList[i].serviceType = userBusinessParamList[
                  i
                ].serviceType.split(",");
              } else {
                var data = [];
                data.push(userBusinessParamList[i].serviceType);
                userBusinessParamList[i].serviceType = data;
              }
            }
            this.userBusinessParamList.push(userBusinessParamList[i]);
          }
        }
        if (this.userBusinessParamList.length == 0) {
          this.userBusinessParamList = [
            {
              settledType: res.data.providerType?res.data.providerType:1,
              userType: 3,
              serviceType: "",
              achievementList: [{}],
            },
          ];
        }
        if (res.data.currentUserType == 3) {
          var userIndustryList = res.data.userIndustryList;
          var industry = [];
          for (let i = 0; i < userIndustryList.length; i++) {
            industry.push(userIndustryList[i].industry);
          }
          this.industry = industry;
          this.userIndustryList = userIndustryList;
          this.info.providerType = this.$route.query.type;
          var userAuthFileList = "";
          this.other = this.$route.query.type;
          if (this.$route.query.type == 1) {
            userAuthFileList = res.data.userAuthFileList;
            var arr = [];
            if (userAuthFileList.length != 0) {
              for (var i = 0; i < userAuthFileList.length; i++) {
                for (var j = 0; j < this.personList.length; j++) {
                  if (
                    userAuthFileList[i].userType == 3 &&
                    userAuthFileList[i].authFileType == this.personList[j].authFileType
                  ) {
                    this.personList[j].fileUrl = userAuthFileList[i].fileUrl;
                    this.personList[j].fileName = userAuthFileList[i].fileName;
                  }
                }
                if (
                  userAuthFileList[i].userType == 3 &&
                  userAuthFileList[i].settledType == 1 &&
                  userAuthFileList[i].authFileType != "zdy1" &&
                  userAuthFileList[i].authFileType != "other1" &&
                  userAuthFileList[i].authFileType != "pzcf" &&
                  userAuthFileList[i].authFileType != "pzgf" &&
                  userAuthFileList[i].authFileType != "pcardzs" &&
                  userAuthFileList[i].authFileType != "pcardfs"
                ) {
                  if (userAuthFileList[i].fileUrl) {
                    arr.push(userAuthFileList[i]);
                  }
                }
              }
              this.personList = [...this.personList, ...arr];
            }
            this.showUpload();
          }
          if (this.$route.query.type == 2) {
            userAuthFileList = res.data.userAuthFileList;
            if (userAuthFileList.length != 0) {
              for (var i = 0; i < userAuthFileList.length; i++) {
                for (var j = 0; j < this.workList.length; j++) {
                  if (userAuthFileList[i].authFileType == this.workList[j].authFileType) {
                    this.workList[j] = userAuthFileList[i];
                  }
                }
              }
            }
          }
          if (this.$route.query.type == 3) {
            userAuthFileList = res.data.userAuthFileList;
            if (userAuthFileList.length != 0) {
              for (var i = 0; i < userAuthFileList.length; i++) {
                for (var j = 0; j < this.firmList.length; j++) {
                  if (userAuthFileList[i].authFileType == this.firmList[j].authFileType) {
                    this.firmList[j] = userAuthFileList[i];
                  }
                }
              }
            }
          }
        }
        if (res.data.userPersonalExpertParam) {
          //个人信息
          var userPersonalExpertParam = res.data.userPersonalExpertParam;
          if (!userPersonalExpertParam.isExpert) {
            this.userPersonalExpertParam.isExpert = false;
            this.placeholder =
              "项目时间-编制-项目名称 （例：2015-编制-年产25万吨高性能改性树脂项目）";
          } else {
            this.placeholder =
              "项目时间-编制/评审-项目名称 （例：2015-评审-年产25万吨高性能改性树脂项目）";
          }
          if (userPersonalExpertParam.contactAddressCode) {
            userPersonalExpertParam.contactAddressCode = userPersonalExpertParam.contactAddressCode.split(
              ","
            );
            if (userPersonalExpertParam.contactAddressCode.length == 3) {
              userPersonalExpertParam.contactAddressCode.splice(2, 1);
            }
          }
          this.userPersonalExpertParam = userPersonalExpertParam;
          if (this.userPersonalExpertParam.workMajor) {
            this.userPersonalExpertParam.workMajor = userPersonalExpertParam.workMajor.split(
              ","
            );
            if (this.userPersonalExpertParam.workMajor.length > 3) {
              this.userPersonalExpertParam.workMajor = [];
            }
          }
          if (userPersonalExpertParam.userPersonalExpertList) {
            if (userPersonalExpertParam.userPersonalExpertList.length != 0) {
              this.userPersonalExpertParam.userPersonalExpertList =
                userPersonalExpertParam.userPersonalExpertList;
            } else {
              this.userPersonalExpertParam.userPersonalExpertList = [
                {
                  storageName: "",
                  storageTime: "",
                },
              ];
            }
          } else {
            this.userPersonalExpertParam.userPersonalExpertList = [
              {
                storageName: "",
                storageTime: "",
              },
            ];
          }
        }
        if (res.data.userEnterprise) {
          this.userEnterprise = res.data.userEnterprise; //企业信息
          if (res.data.userEnterprise.contactAddressCode) {
            this.userEnterprise.contactAddressCode = res.data.userEnterprise.contactAddressCode.split(
              ","
            );
            if (this.userEnterprise.contactAddressCode.length == 3) {
              this.userEnterprise.contactAddressCode.splice(2, 1);
            }
          }
        }
        if (res.data.userStudio) {
          this.userStudio = res.data.userStudio; //工作室信息
          if (res.data.userStudio.contactAddressCode) {
            this.userStudio.contactAddressCode = res.data.userStudio.contactAddressCode.split(
              ","
            );
            if (this.userStudio.contactAddressCode.length == 3) {
              this.userStudio.contactAddressCode.splice(2, 1);
            }
          }
        }
        if (res.data.userConsultCreditList.length != 0) {
          //工程咨询
          var userConsultCreditList = res.data.userConsultCreditList;
          for (var i = 0; i < userConsultCreditList.length; i++) {
            if (
              userConsultCreditList[i].industry[0] &&
              userConsultCreditList[i].industry[0] != 4
            ) {
              this.xuanze = true;
            } else {
              this.xuanze = false;
            }
            userConsultCreditList[i].industry = userConsultCreditList[i].industry.split(
              ","
            );
          }
          this.userConsultCreditList = userConsultCreditList;
        }
      });
    },
    // 切换行业
    changeIndustry(val) {
      var industrylist = [];
      for (let i = 0; i < val.length; i++) {
        var obj = {};
        obj.industry = val[i];
        obj.userType = this.info.currentUserType;
        obj.settledType = this.info.consumerType;
        industrylist.push(obj);
      }
      this.userIndustryList = industrylist;
    },

    // 选择服务内容
    chooseServiceContent(val) {
      if (val.length == 0) {
        this.tip = 1;
      } else {
        this.tip = 0;
      }
    },

    // 切换工程咨询资信
    changeCredit() {
      var userConsultCreditList = this.userConsultCreditList;
      console.log(userConsultCreditList);
      for (var i = 0; i < userConsultCreditList.length; i++) {
        if (
          userConsultCreditList[i].industry[0] &&
          userConsultCreditList[i].industry[0] != 4
        ) {
          this.xuanze = true;
        } else {
          this.xuanze = false;
        }
      }
    },

    // 添加工程咨询资信
    addConsult() {
      var obj = {};
      obj.industry = "";
      obj.credit = "";
      this.userConsultCreditList.push(obj);
    },
    delConsult(index) {
      this.userConsultCreditList.splice(index, 1);
    },

    // 切换职称类型
    changeJobT(val) {
      if (val == 3 || val == 4 || val == 5) {
        this.userPersonalExpertParam.isExpert = false;
        this.changExpert(false);
        this.placeholder =
          "项目时间-编制-项目名称 （例：2015-编制-年产25万吨高性能改性树脂项目）";
      }
    },

    // 切换是否专家
    changExpert(val) {
      var userBusinessParamList = this.userBusinessParamList;
      for (var i = 0; i < userBusinessParamList.length; i++) {
        userBusinessParamList[i].serviceType = "";
        if (val == false) {
          userBusinessParamList[i].isAssess = false;
          this.placeholder =
            "项目时间-编制-项目名称 （例：2015-编制-年产25万吨高性能改性树脂项目）";
        } else {
          this.placeholder =
            "项目时间-编制/评审-项目名称 （例：2015-评审-年产25万吨高性能改性树脂项目）";
        }
      }
      this.userBusinessParamList = userBusinessParamList;
    },

    // 选择业务类型
    changeBusType(index) {
      this.userBusinessParamList[index].serviceType = "";
    },
    // 添加业务模块
    addBus() {
      var obj = {};
      obj.serviceType = "";
      obj.settledType = this.other;
      obj.userType = 3;
      obj.achievementList = [{}];
      this.userBusinessParamList.push(obj);
    },

    //删除业务模块
    removeBus(index) {
      this.userBusinessParamList.splice(index, 1);
    },

    // 选择服务类型
    changeThis() {
      this.$forceUpdate();
    },

    //选择服务内容
    changeSer(val) {
      var list = this.userBusinessParamList;
      var flag = true;
      for (var i = 0; i < list.length; i++) {
        for (var j = i + 1; j < list.length; j++) {
          if (list[i].serviceType && list[j].serviceType) {
            if (list[i].serviceType == list[j].serviceType) {
              flag = false;
              list[j].serviceType = "";
              break;
            }
          }
        }
      }
      if (flag == false) {
        this.$message.info("服务内容不能选择相同的");
        val = "";
      }
    },

    // 添加业绩
    addInfo(index) {
      var obj = {};
      obj.achievementIntro = "";
      if (this.userBusinessParamList[index].achievementList.length >= 5) {
        this.$message.info("业绩最多5条,不能再增加");
        return;
      }
      this.userBusinessParamList[index].achievementList.push(obj);
    },

    // 删除业绩
    removeInfo(index, indexf) {
      this.userBusinessParamList[index].achievementList.splice(indexf, 1);
    },

    // 上传其他证书
    uploadOther(index) {
      var obj = {};
      obj.fileUrl = "";
      obj.fileName = "";
      (obj.authFileType = "zdy" + index), (obj.settledType = index);
      obj.userType = 3;
      this.otherList.push(obj);
    },

    // 上传图片
    handleAvatarSuccessT(res, file, type, index) {
      if (this.info.providerType == 1) {
        if (type) {
          var obj = {};
          obj.fileName = res.data.fileName;
          obj.fileUrl = res.data.fileUrl;
          obj.settledType = this.info.providerType;
          obj.authFileType = type;
          obj.userType = 3;
          this.personList.push(obj);
          this.showUpload();
        } else {
          this.personList[index].fileName = res.data.fileName;
          this.personList[index].fileUrl = res.data.fileUrl;
          this.personList[index].settledType = this.info.providerType;
          this.personList[index].userType = 3;
        }
      }
      if (this.info.providerType == 2) {
        this.workList[index].fileName = res.data.fileName;
        this.workList[index].fileUrl = res.data.fileUrl;
        this.workList[index].settledType = this.info.providerType;
      }
      if (this.info.providerType == 3) {
        this.firmList[index].fileName = res.data.fileName;
        this.firmList[index].fileUrl = res.data.fileUrl;
        this.firmList[index].settledType = this.info.providerType;
      }
    },
    beforeAvatarUploadT(file) {
      const isJPG = file.type.split("/")[0] === "image";
      const isLt1G = file.size / 1024 / 1024 / 10 < 1;
      if (!isLt1G) {
        this.$message.error("文件大小超过 10M!");
      }
      if (!isJPG) {
        this.$message.error("只能上传图片格式!");
      }
      return isJPG && isLt1G;
    },

    // 删除扫描件
    removeImg(index, zhi) {
      if (zhi) {
        this.personList.splice(index, 1);
        this.showUpload();
      } else {
        if (this.info.providerType == 1) {
          this.personList[index].fileUrl = "";
        }
        if (this.info.providerType == 2) {
          this.workList[index].fileUrl = "";
        }
        if (this.info.providerType == 3) {
          this.firmList[index].fileUrl = "";
        }
      }
    },

    // 判断上传是否显示
    showUpload() {
      var pzcArr = [];
      var pzgArr = [];
      var ryArr = [];
      var rkArr = [];
      var personList = this.personList;
      for (var i = 0; i < personList.length; i++) {
        if (personList[i].authFileType == "pzc") {
          pzcArr.push(personList[i]);
        }
        if (personList[i].authFileType == "pzg") {
          pzgArr.push(personList[i]);
        }
        if (personList[i].authFileType == "ryzs") {
          ryArr.push(personList[i]);
        }
        if (personList[i].authFileType == "rkzm") {
          rkArr.push(personList[i]);
        }
      }
      this.pzcLength = pzcArr.length;
      this.pzgLength = pzgArr.length;
      this.ryLength = ryArr.length;
      this.rkLength = rkArr.length;
    },

    // 提交数据
    save(info) {
      // 服务商提交信息
      var imgList = [];
      if (this.info.providerType == 1) {
        imgList = this.personList;
      }
      if (this.info.providerType == 2) {
        imgList = this.workList;
      }
      if (this.info.providerType == 3) {
        imgList = this.firmList;
      }
      var list = this.userBusinessParamList;
      for (var i = 0; i < list.length; i++) {
        if (list[i].serviceType.length == 0) {
          this.$message.error("请选择服务内容");
          return;
        }
        if (list[i].serviceType == 211 || list[i].serviceType == 212) {
          list[i].isOrganization = false;
        }
        if (
          this.userPersonalExpertParam.isExpert == true &&
          (this.userPersonalExpertParam.jobTitle == 1 ||
            this.userPersonalExpertParam.jobTitle == 2) &&
          this.info.providerType == 1
        ) {
          if (!list[i].isAssess && !list[i].isOrganization) {
            this.$message.error("请选择业务类型");
            return;
          }
        }
        for (var j = 0; j < list[i].achievementList.length; j++) {
          if (!list[i].achievementList[j].achievementIntro) {
            this.$message.error("请填写业绩");
            return;
          }
        }
      }
      this.userBusinessParamList = list;
      if (this.info.providerType == 1 && this.info.currentUserType == 3) {
        // 个人类型传值
        this.$refs[info].validate((valid) => {
          if (!valid) {
            this.$message.info('有必填项填写错误')
             document.body.scrollTop = 60
             document.documentElement.scrollTop= 60
            return
          }
          if (valid) {
            this.userPersonalExpertParam.contactAddressCode = this.userPersonalExpertParam.contactAddressCode.toString();
            this.userPersonalExpertParam.contactAddressDetail = "";
            if (this.userPersonalExpertParam.workMajor) {
              this.userPersonalExpertParam.workMajor = this.userPersonalExpertParam.workMajor.toString();
            }
            if (this.info.providerType == 1) {
              var picList = [];
              for (var i = 0; i < imgList.length; i++) {
                if (this.userPersonalExpertParam.isExpert == false) {
                  if (
                    imgList[i].authFileType != "ryzs" &&
                    imgList[i].authFileType != "rkzm"
                  ) {
                    picList.push(imgList[i]);
                  }
                }
                if (imgList[i].authFileType == "pcardzs") {
                  if (imgList[i].fileUrl == "") {
                    this.$message.error("请上传身份证正面");
                    return;
                  }
                }
                if (imgList[i].authFileType == "pcardfs") {
                  if (imgList[i].fileUrl == "") {
                    this.$message.error("请上传身份证反面");
                    return;
                  }
                }
              }
              if (this.userPersonalExpertParam.jobTitle) {
                if (this.userPersonalExpertParam.jobTitle != 5) {
                  if (this.pzcLength == 0) {
                    this.$message.error("请至少上传一张职称证");
                    return;
                  }
                }
              }
              if (this.userPersonalExpertParam.qualificationName) {
                if (this.pzgLength == 0) {
                  this.$message.error("请至少上传一张职业资格证");
                  return;
                }
              }
            }
            if (
              this.userPersonalExpertParam.jobTitle == 3 ||
              this.userPersonalExpertParam.jobTitle == 4 ||
              this.userPersonalExpertParam.jobTitle == 5
            ) {
              this.userPersonalExpertParam.isExpert = false;
            }
            var imgs = [];
            if (this.userPersonalExpertParam.isExpert) {
              imgs = imgList;
            } else {
              imgs = picList;
            }
            for (var i = 0; i < list.length; i++) {
              list[i].serviceType = list[i].serviceType.toString();
              if (
                this.userPersonalExpertParam.jobTitle == 1 ||
                this.userPersonalExpertParam.jobTitle == 2
              ) {
                if (this.userPersonalExpertParam.isExpert == false) {
                  list[i].isAssess = false;
                }
              }
              if (
                this.userPersonalExpertParam.jobTitle == 3 ||
                this.userPersonalExpertParam.jobTitle == 4 ||
                this.userPersonalExpertParam.jobTitle == 5
              ) {
                list[i].isAssess = false;
              }
              this.userBusinessParamList[i] = list[i];
            }
            // console.log(
            //   imgs.filter((e) => {
            //     return e.authFileType == "pzc";
            //   })
            // );
            this.$post(
              "/sys/user/auth",
              {
                currentUserType: "3",
                providerType: this.info.providerType,
                userPersonalExpertParam: this.userPersonalExpertParam,
                userAuthFileList: imgs,
                userIndustryList: this.userIndustryList,
                id: this.info.id,
                userBusinessParamList: this.userBusinessParamList,
              },
              function (res) {
                if (res.code == 200) {
                  this.$message.success("提交成功!");
                  this.$router.replace("/person/index");
                } else {
                  this.$message.error(res.msg);
                }
              },
              true
            );
          }

        })
      }
      if (this.info.providerType == 2 && this.info.currentUserType == 3) {
        this.$refs[info].validate((valid) => {
          if (!valid) {
            this.$message.info('有必填项填写错误')
             document.body.scrollTop = 60
             document.documentElement.scrollTop= 60
            return
          }
          if (valid) {
            // 工作室类型传值

            this.userStudio.contactAddressCode = this.userStudio.contactAddressCode.toString();
            this.userStudio.contactAddressDetail = "";
            if (this.info.providerType == 2) {
              if (this.userStudio.jobTitle) {
                if (this.userStudio.jobTitle != 4) {
                  for (var i = 0; i < imgList.length; i++) {
                    if (imgList[i].authFileType == "wzc") {
                      if (imgList[i].fileUrl == "") {
                        this.$message.error("请上传负责人职称证");
                        return;
                      }
                    }
                    // if (imgList[i].authFileType == 'wzcf') {
                    //   if (imgList[i].fileUrl == '') {
                    //     this.$message.error('请上传负责人职称证内容面');
                    //     return
                    //   }
                    // }
                  }
                }
              }
              if (this.userStudio.qualificationName) {
                for (var i = 0; i < imgList.length; i++) {
                  if (imgList[i].authFileType == "wzg") {
                    if (imgList[i].fileUrl == "") {
                      this.$message.error("请上传负责人职业资格证");
                      return;
                    }
                  }
                  // if (imgList[i].authFileType == 'wzgf') {
                  //   if (imgList[i].fileUrl == '') {
                  //     this.$message.error('请上传负责人职业资格证内容面');
                  //     return
                  //   }
                  // }
                }
              }
              for (var i = 0; i < imgList.length; i++) {
                if (imgList[i].authFileType == "wcardz") {
                  if (imgList[i].fileUrl == "") {
                    this.$message.error("请上传负责人身份证正面");
                    return;
                  }
                }
                if (imgList[i].authFileType == "wcardf") {
                  if (imgList[i].fileUrl == "") {
                    this.$message.error("请上传负责人身份证反面");
                    return;
                  }
                }
              }
            }
            for (var i = 0; i < list.length; i++) {
              list[i].serviceType = list[i].serviceType.toString();
              this.userBusinessParamList[i] = list[i];
            }
            this.userAuthFileList = imgList;
            this.$post(
              "/sys/user/auth",
              {
                currentUserType: "3",
                providerType: this.info.providerType,
                userStudio: this.userStudio,
                userAuthFileList: this.userAuthFileList,
                userIndustryList: this.userIndustryList,
                id: this.info.id,
                userBusinessParamList: this.userBusinessParamList,
              },
              function (res) {
                if (res.code == 200) {
                  this.$message.success("提交成功!");
                  this.$router.replace("/person/index");
                } else {
                  this.$message.error(res.msg);
                }
              },
              true
            );

          }
        })
      }
      if (this.info.providerType == 3 && this.info.currentUserType == 3) {
        this.$refs[info].validate((valid) => {
          if (!valid) {
            this.$message.info('有必填项填写错误')
             document.body.scrollTop = 60
             document.documentElement.scrollTop= 60
            return
          }
          if (valid) {
            // 企业类型传值

            for (var i = 0; i < imgList.length; i++) {
              if (imgList[i].authFileType == "fyyzz") {
                if (imgList[i].fileUrl == "") {
                  this.$message.error("请上传营业执照");
                  return;
                }
              }
              if (imgList[i].authFileType == "fcardz") {
                if (imgList[i].fileUrl == "") {
                  this.$message.error("请上传负责人身份证正面");
                  return;
                }
              }
              if (imgList[i].authFileType == "fcardf") {
                if (imgList[i].fileUrl == "") {
                  this.$message.error("请上传负责人身份证反面");
                  return;
                }
              }
              if (imgList[i].authFileType == "fzxzs") {
                if (this.xuanze == true && imgList[i].fileUrl == "") {
                  this.$message.error("请上传资信证书");
                  return;
                }
              }
            }
            this.userEnterprise.contactAddressCode = this.userEnterprise.contactAddressCode.toString();
            this.userEnterprise.contactAddressDetail = "";
            var userConsultCreditList = this.userConsultCreditList;
            for (var i = 0; i < userConsultCreditList.length; i++) {
              if (
                userConsultCreditList[i].industry == "" ||
                userConsultCreditList[i].credit == ""
              ) {
                this.$message.error("请选择工程资讯资信");
                return;
              }
              userConsultCreditList[i].industry = userConsultCreditList[
                i
              ].industry.toString();
            }
            for (var i = 0; i < list.length; i++) {
              list[i].serviceType = list[i].serviceType.toString();
              this.userBusinessParamList[i] = list[i];
            }
            this.userAuthFileList = imgList;
            this.$post(
              "/sys/user/auth",
              {
                currentUserType: "3",
                providerType: this.info.providerType,
                userEnterprise: this.userEnterprise,
                userConsultCreditList: userConsultCreditList,
                userAuthFileList: this.userAuthFileList,
                userIndustryList: this.userIndustryList,
                id: this.info.id,
                userBusinessParamList: this.userBusinessParamList,
              },
              function (res) {
                if (res.code == 200) {
                  this.$message.success("提交成功!");
                  this.$router.replace("/person/index");
                } else {
                  this.$message.error(res.msg);
                }
              },
              true
            );

          }

        })
      }
      
    },
  },
  mounted() {
    this.headers = {
      Authorization: "bearer " + getSession("token").access_token,
    };
    this.getInfo();
  },
};
